import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, Button, Text } from '@components/common';
import { MobileContainer } from '@containers/layout';
import DefaultLoader from '@components/loading/DefaultLoader';

import API from '@utils/api';

function ReadKeyRelease(props) {
  const { onSubmit, propertyID } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [keyRelease, setKeyRelease] = useState('');

  useEffect(() => {
    const fetchRelease = async () => {
      setIsLoading(true);
      const {
        result: { keyRelease: keyReleaseFromApi }
      } = await API.getKeyReleaseInfo(propertyID);

      setKeyRelease(keyReleaseFromApi);
      setIsLoading(false);
    };
    fetchRelease();
  }, [propertyID]);

  return (
    <MobileContainer>
      <Heading mb={4}>Full Key Release Terms</Heading>
      {isLoading && (
        <Box
          flex={1}
          display="flex"
          alignSelf="stretch"
          flexDirection="column"
          justifyContent="center"
          alignItems="Center"
        >
          <DefaultLoader size={64} />
        </Box>
      )}
      {!isLoading && <Text mb={5}>{keyRelease}</Text>}
      <Button width={1} mb={4} type="button" onClick={onSubmit}>
        Done
      </Button>
    </MobileContainer>
  );
}

ReadKeyRelease.propTypes = {
  onSubmit: PropTypes.func,
  propertyID: PropTypes.any
};

export default ReadKeyRelease;
